import { Directive, effect, EffectRef, ElementRef, inject, input, InputSignal } from '@angular/core';
import { ProductModel} from '@libs/shop/models';
import { TrackingAvailability, TrackingProductModel } from '@libs/shop/models';
import { ProductTrackingListDirective } from '../context';
import { ProductImpressionObserverService } from './product-impression-observer.service';

@Directive({ selector: '[uiProductImpression]' })
export class ProductImpressionDirective {
  public product: InputSignal<ProductModel> = input.required();
  public position: InputSignal<number> = input.required();
  public availability: InputSignal<TrackingAvailability | undefined> = input<TrackingAvailability | undefined>();

  private readonly elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly impressionObserver: ProductImpressionObserverService = inject(ProductImpressionObserverService);
  private readonly productTrackingList: ProductTrackingListDirective | null = inject(ProductTrackingListDirective, { optional: true });

  private readonly observeProductImpression: EffectRef = effect((): void => {
    const impression: TrackingProductModel = {
      ...this.product(),
      type: 'product',
      position: this.position(),
      quantity: 1,
      availability: this.availability(),
      trackingList: this.productTrackingList?.trackingList(),
    };

    this.impressionObserver.observeElement(this.elementRef.nativeElement, impression);
  });
}
